import { LazyAction, LazyModule, LazyImport, createLazyComponent } from 'owa-bundling';

// NOTE: these non-lazy actions are for subscription purposes only; do not invoke
export { openMobilityCompose } from './actions/openMobilityCompose';
export { closeMobilityCompose } from './actions/closeMobilityCompose';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "MobilityCompose"*/ './lazyIndex')
);

// lazy actions
export let lazyOpenMobilityCompose = new LazyAction(lazyModule, m => m.openMobilityCompose);
export let lazySaveTravelBookends = new LazyAction(lazyModule, m => m.saveTravelBookends);
export let lazyDiscardTravelBookends = new LazyAction(lazyModule, m => m.discardTravelBookends);

// lazy components
export const MobilityComposeForm = createLazyComponent(lazyModule, m => m.MobilityComposeForm);
export const MobilityFullComposeRow = createLazyComponent(
    lazyModule,
    m => m.MobilityFullComposeRow
);
export const MobilityAddTravelTime = createLazyComponent(lazyModule, m => m.MobilityAddTravelTime);

// lazy imports
export let lazyCanTravelToEvent = new LazyImport(lazyModule, m => m.canTravelToEvent);
export let lazyGetSchedulingGridBookends = new LazyImport(
    lazyModule,
    m => m.getSchedulingGridBookends
);
